import { createDataFetchSlice } from 'redux/utils/dataFetch';
import { ClientProfileExtViewModel } from '../../../../common/model/client/clientProfileExtViewModel';

export const clientProfileSlice = createDataFetchSlice<ClientProfileExtViewModel>({ name: 'clientProfile' });
